import PropTypes, { any } from 'prop-types';
import React from 'react';

import { ENUM_MODULE_NAME } from '../../../commons/utils/features';
import { STOCKS_FEATURE_PATHS } from '../../../commons/utils/featurePaths';

import { ModuleContainer } from '../../ModuleContainer';

export const StocksAnalyticsContainer = (props) => {
  const { userRights, history } = props;

  return (
    <ModuleContainer
      history={history}
      moduleFeaturePaths={[
        STOCKS_FEATURE_PATHS.STOCKS_ANALYTICS_CURRENT,
        STOCKS_FEATURE_PATHS.STOCKS_ANALYTICS_PAST,
        STOCKS_FEATURE_PATHS.STOCKS_ANALYTICS_PAST_DEPRECATED,
      ]}
      moduleName={ENUM_MODULE_NAME.STOCK}
      userRights={userRights}
    />
  );
};

StocksAnalyticsContainer.propTypes = {
  userRights: PropTypes.array,
  history: any, // react-router-dom's route prop
  moduleName: PropTypes.oneOf(Object.values(ENUM_MODULE_NAME)),
  moduleFeaturePaths: PropTypes.arrayOf(PropTypes.string),
};

export default StocksAnalyticsContainer;
